
const freteStatus = [
  { id: 'CR', nome: 'Cadastrado' },                                     // 1 - Embarcador
  { id: 'CA', nome: 'Cancelado' },
  { id: 'OF', nome: 'Em Oferta' },                                      // 2 - Embarcador
  { id: 'NE', nome: 'Em Negociação' },                                  // 3 - Embarcador - Transportador
  { id: 'AA', nome: 'Em Coleta - Aguardando autorização' },
  { id: 'CO', nome: 'Em Coleta - Aguardando chegada do motorista' },    // 
  { id: 'AC', nome: 'Em Coleta - Aguardando finalizar carregamento' },
  { id: 'AE', nome: 'Carregado - Aguardando envio de NF-e' },
  { id: 'AP', nome: 'Carregado - Aguardando pagamento' },
  { id: 'PA', nome: 'Pago. Aguardando saída' },
  { id: 'TR', nome: 'Em Trânsito' },
  { id: 'EN', nome: 'Entregue' },
  { id: 'FI', nome: 'Finalizado' }
]

export default freteStatus



// WEBPACK FOOTER //
// ./src/vuex/cache/freteStatus.js